import { createContext, useContext, useState, useEffect } from 'react'
import { settingsAPI } from '../services/api'

const SiteConfigContext = createContext()

const DEFAULT_NAV_ORDER = [
  'home', 'about', 'services', 'team', 'coverage', 'blog',
  'forum', 'store', 'testimonials', 'faq', 'downloads', 'contact',
]

const defaults = {
  phone: '+58 424 2609144',
  whatsapp: '584242609144',
  email: 'direccion.medica@genikadomicilio.com',
  address: 'Caracas, Venezuela',
  scheduleWeekdays: '8:00 AM - 6:00 PM',
  scheduleSaturday: '9:00 AM - 2:00 PM',
  scheduleSunday: 'Emergencias 24/7',
  facebookUrl: 'https://www.facebook.com/p/genikasalud-100064049526637/',
  instagramUrl: 'https://www.instagram.com/genika.domicilio',
  youtubeUrl: '',
  linkedinUrl: '',
  spotEnabled: false,
  spotVideoUrl: '',
  spotPage: 'home',
  spotPosition: 'bottom',
  comingSoonEnabled: false,
  comingSoonDate: '',
  navItems: {
    home: true,
    about: true,
    services: true,
    team: true,
    coverage: false,
    blog: true,
    forum: false,
    store: true,
    testimonials: true,
    faq: false,
    downloads: true,
    contact: true
  },
  navOrder: [...DEFAULT_NAV_ORDER],
}

function mergeNavOrder(stored) {
  if (!Array.isArray(stored)) return [...DEFAULT_NAV_ORDER]
  const set = new Set(stored)
  const missing = DEFAULT_NAV_ORDER.filter((k) => !set.has(k))
  return [...stored.filter((k) => DEFAULT_NAV_ORDER.includes(k)), ...missing]
}

export function SiteConfigProvider({ children }) {
  const [siteConfig, setSiteConfig] = useState(defaults)
  const [loading, setLoading] = useState(true)

  const applyConfig = (data) => {
    setSiteConfig({
      ...defaults,
      ...data,
      navItems: { ...defaults.navItems, ...(data.navItems || {}) },
      navOrder: mergeNavOrder(data.navOrder),
    })
  }

  useEffect(() => {
    settingsAPI.get()
      .then(res => applyConfig(res.data))
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [])

  const refresh = () => {
    settingsAPI.get()
      .then(res => applyConfig(res.data))
      .catch(() => {})
  }

  return (
    <SiteConfigContext.Provider value={{ siteConfig, loading, refresh }}>
      {children}
    </SiteConfigContext.Provider>
  )
}

export function useSiteConfig() {
  const context = useContext(SiteConfigContext)
  if (!context) {
    throw new Error('useSiteConfig must be used within SiteConfigProvider')
  }
  return context
}
